import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const CustomModal = ({ triggerLabel, title, body, buttons, onCloseAction, buttonDisabled }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    // esegue azione opzionale (X, ESC, backdrop, bottoni...)
    if (onCloseAction) onCloseAction();

    setShow(false);
  };

  const handleOpen = () => setShow(true);

  const renderButtons = buttons?.map((btn, index) => (
    <Button
      key={index}
      variant={btn.variant || 'secondary'}
      onClick={() => {
        if (btn.onClick) btn.onClick();
        handleClose();
      }}>
      {btn.label}
    </Button>
  ));

  return (
    <>
      <Button variant='primary' onClick={handleOpen} disabled={buttonDisabled}>
        {triggerLabel}
      </Button>

      <Modal
        show={show}
        onHide={handleClose} // ← X, ESC, backdrop
        centered
        size='xl'>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>{body}</Modal.Body>

        <Modal.Footer>{renderButtons}</Modal.Footer>
      </Modal>
    </>
  );
};

export default CustomModal;
